module.exports = __webpack_public_path__ + "static/img/hangpai_04.89283c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hangpai_04.png
// module id = V5nT
// module chunks = 1